<template>
  <div class="animated fadeIn">
    <b-modal ref="my-modal" hide-footer title="CONCLUIR VISTORIA">
      <div class="form-group row pt-2">
        <div class="col-md-12 text-center">
          <h3>Deseja concluir a vistoria?</h3>
          <div class="text-muted">Uma você concluída a vistoria não poderá mais ser editada</div>
        </div>
      </div>
      <div class="form-group row pt-2 pb-3">
        <div class="col-md-12 text-center">
          <b-button class="mt-2" variant="danger" @click="hideModal">&nbsp;<i class="fa fa-times-circle" aria-hidden="true"></i> <strong>Não &nbsp;</strong></b-button>&nbsp;
          <b-button class="mt-2" variant="success" @click="onClosing">&nbsp;<i class="fa fa-check-circle" aria-hidden="true"></i> <strong>Sim &nbsp;</strong></b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import RegulationMixin from '@/store/module/regulation/mixin'
import PermissionMixin from '@/store/module/permission/mixin'
import RegulationAutoRepository from '@/shared/http/repositories/regulation/auto/regulationauto.js'

export default {
  name: 'ModalSinisterClosing',
  mixins: [ActionsForm, RegulationMixin, PermissionMixin],
  data () {
    return {
      data: null,
      form: null,
      regulationID: null
    }
  },
  methods: {
    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    showModal (regulationID) {
      if (regulationID) {
        this.$refs['my-modal'].show()
        this.regulationID = regulationID
      }
    },
    hideModal () {
      this.$refs['my-modal'].hide()
    },
    onLoad () {
      if (this.hasRegulation) {
      }
    },
    onClosing () {
      if (this.regulationID) {
        this.hideModal()
        loading.push()
        RegulationAutoRepository.ChangeStageRegulationCompleted(this.regulationID)
          .then((response) => {
            loading.close()
            if (response.data.code >= 0) {
              var data = response.data.data
              toast.success(this.$lang.Common.Alerts.Success)
              this.isCompleted = true
              this.$emit('Closed', data)
            }
          })
          .catch((err) => {
            this.onException(err)
          })
      } else {
        this.hideModal()
        toast.warning('Vistoria não selecionada.<br>Abra a vistoria novamente, por favor!')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/inspection/typing/modal/modalsinisterclosing.vue